import { render, staticRenderFns } from "./ItemHelp.vue?vue&type=template&id=3da93324&scoped=true"
import script from "./ItemHelp.vue?vue&type=script&lang=js"
export * from "./ItemHelp.vue?vue&type=script&lang=js"
import style0 from "./ItemHelp.vue?vue&type=style&index=0&id=3da93324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da93324",
  null
  
)

export default component.exports